// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-79779609\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../../../../node_modules/stylus-loader/index.js!../../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Message.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("5a2a3652", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79779609","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/settings/components/message/Message.vue
// module id = 1ff36541ea4c20962baa
// module chunks = 0